module.exports = __webpack_public_path__ + "media/images/upload-file-outlined-gray-d43c192b.svg";